import Vue from "vue"
import { getCartDetailV2, addToCartV2, modifyCartV2 } from "@/api/cart"
import { getRangeStore, getRangeSlaveStoreList, getWareItems, getUniqWares } from "@/components/cart/js/common"
import { getDeliveryMethod } from "@/utils/utils"

export const callAsync = promise => {
  return promise
    .then(data => {
      return [null, data]
    })
    .catch(error => {
      return [error, null]
    })
}

// 获取所有的商品
export const getAllWares = data => {
  const store = getRangeStore(data) // 主门店
  const slaveStoreList = getRangeSlaveStoreList(data) // 从门店

  const items = [...getWareItems(2, store)]

  // 自提模式下，只限送货的商品加购后也需要回显数量
  if (getDeliveryMethod() === "clickCollect") {
    items.push(...getWareItems(-1, store))
  }

  slaveStoreList.forEach(item => {
    items.push(...getWareItems(2, item))

    // 自提模式下，只限送货的商品加购后也需要回显数量
    if (getDeliveryMethod() === "clickCollect") {
      items.push(...getWareItems(-1, item))
    }
  })

  return getUniqWares(items)
}

// 处理公共逻辑
export const handleCartCommon = data => {
  const store = getRangeStore(data)

  const tip =
    getDeliveryMethod() === "homeDelivery"
      ? (store.deliveryExpense && store.deliveryExpense.tip) || ""
      : (store.pickupExpenseResponse && store.pickupExpenseResponse.minPriceTip) || ""
  const rate =
    getDeliveryMethod() === "homeDelivery"
      ? (store.deliveryExpense && store.deliveryExpense.rate) || 0
      : store.pickupMinPriceFlag === 1
        ? 1
        : 0

  Vue.prototype.$bus.$emit("setOnlineStoreTags", {
    tip,
    rate
  })
  Vue.prototype.$bus.$emit("setCartCount", data.checkedCount)
}

export const handleGetCartDetailV2 = async () => {
  const params = {
    isCollage: false,
    sort: 0,
    simple: 1
  }
  const [error, res] = await callAsync(getCartDetailV2({ param: JSON.stringify(params) }))

  let wareList = []
  if (res && res.data) {
    handleCartCommon(res.data)

    wareList = getAllWares(res.data)
    Vue.prototype.$bus.$emit("getCartSkuList", wareList)
  }

  return [error, res && res.data, wareList]
}

export const getParams = ({ venderId, storeId, wares, sort, simple, otherParams }) => {
  return {
    isCollage: false,
    sort,
    simple,
    storeGroup: [
      {
        venderId,
        erpStoreId: storeId, // 149
        wares: wares.map(ware => ({
          sku: ware.sku || ware.skuId, // 104723678
          checked: 1,
          beforeCount: ware.beforeCount || 0,
          count: ware.count,
          ...otherParams
        }))
      }
    ]
  }
}

export const handleAddToCartV2 = async ({ venderId, storeId, wares = [], sort = 1, simple = 0, otherParams = {} }) => {
  const params = getParams({
    venderId,
    storeId,
    wares,
    sort,
    simple,
    otherParams
  })
  const [error, res] = await callAsync(addToCartV2({ param: JSON.stringify(params) }))

  let wareList = []
  if (res && res.data) {
    handleCartCommon(res.data)

    wareList = getAllWares(res.data)
  }

  return [error, res && res.data, wareList]
}

export const handleModifyCartV2 = async ({ venderId, storeId, wares = [], sort = 1, simple = 0, otherParams = {} }) => {
  const params = getParams({
    venderId,
    storeId,
    wares,
    sort,
    simple,
    otherParams
  })
  const [error, res] = await callAsync(modifyCartV2({ param: JSON.stringify(params) }))

  let wareList = []
  if (res && res.data) {
    handleCartCommon(res.data)

    wareList = getAllWares(res.data)
  }

  return [error, res && res.data, wareList]
}
